(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cosmetologists"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function norm(s) {
      try {
        return String(s || '')
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');
      } catch (e) {
        return String(s || '').toLowerCase();
      }
    }

    function digits(s) {
      return String(s || '').replace(/\D/g, '');
    }

    function cardMatches(card, q, mode) {
      if (!q) return true;
      var nq = norm(q);
      var qd = digits(q);
      var n = norm(card.getAttribute('data-cos-name') || '');
      var a = norm(card.getAttribute('data-cos-address') || '');
      var c = norm(card.getAttribute('data-cos-city') || '');
      var p = card.getAttribute('data-cos-phone') || '';
      var pd = digits(p);
      var pn = norm(p);
      if (mode === 'name') return n.indexOf(nq) !== -1;
      if (mode === 'address') return a.indexOf(nq) !== -1;
      if (mode === 'city') return c.indexOf(nq) !== -1;
      if (mode === 'phone') return (qd && pd.indexOf(qd) !== -1) || pn.indexOf(nq) !== -1;
      return (
        n.indexOf(nq) !== -1 ||
        a.indexOf(nq) !== -1 ||
        c.indexOf(nq) !== -1 ||
        (qd && pd.indexOf(qd) !== -1) ||
        pn.indexOf(nq) !== -1
      );
    }

    function cardMatchesAll(card, rules) {
      for (var r = 0; r < rules.length; r++) {
        if (!cardMatches(card, rules[r].q, rules[r].mode)) return false;
      }
      return true;
    }

    function collectRules(dir) {
      var inputs = dir.querySelectorAll('[data-cos-filter-input]');
      var rules = [];
      for (var i = 0; i < inputs.length; i++) {
        var inp = inputs[i];
        if (!inp.hasAttribute('data-cos-applied')) continue;
        var q = inp.getAttribute('data-cos-applied');
        if (q === null || q === '') continue;
        q = String(q).trim();
        if (!q) continue;
        rules.push({
          q: q,
          mode: inp.getAttribute('data-cos-filter-mode') || 'name',
        });
      }
      return rules;
    }

    function apply(dir) {
      var rules = collectRules(dir);
      var wrap = dir.querySelector('[data-cos-shared-results]');
      var head = dir.querySelector('[data-cos-results-head]');
      var statusEl = dir.querySelector('[data-cos-results-status]');
      var statusTpl = '__COUNT__ תוצאות עבור __TERMS__';
      var cards = wrap ? wrap.querySelectorAll('.cosmetologist-card') : [];
      var i;
      if (rules.length === 0) {
        for (i = 0; i < cards.length; i++) {
          cards[i].hidden = true;
        }
        if (head) head.hidden = true;
        if (statusEl) statusEl.textContent = '';
      } else {
        var visible = 0;
        for (i = 0; i < cards.length; i++) {
          var ok = cardMatchesAll(cards[i], rules);
          cards[i].hidden = !ok;
          if (ok) visible++;
        }
        if (head) head.hidden = false;
        if (statusEl) {
          var terms = rules
            .map(function (r) {
              return r.q;
            })
            .join(', ');
          statusEl.textContent = statusTpl.replace(/__COUNT__/g, String(visible)).replace(/__TERMS__/g, terms);
        }
      }
    }

    function activateTab(dir, tab) {
      var tabs = dir.querySelectorAll('[data-cos-tab]');
      for (var i = 0; i < tabs.length; i++) {
        var tb = tabs[i];
        var on = tb === tab;
        tb.setAttribute('aria-selected', on ? 'true' : 'false');
        tb.setAttribute('tabindex', on ? '0' : '-1');
        var pid = tb.getAttribute('aria-controls');
        var panel = pid ? document.getElementById(pid) : null;
        if (panel && dir.contains(panel)) panel.hidden = !on;
      }
      if (tab) tab.focus();
    }

    function closeAllComboboxes() {
      document.querySelectorAll('[data-cos-combobox].is-open').forEach(function (box) {
        box.classList.remove('is-open');
        var list = box.querySelector('[data-cos-combobox-list]');
        var inp = box.querySelector('[data-cos-combobox-input]');
        if (list) {
          list.hidden = true;
          list.innerHTML = '';
        }
        if (inp) inp.setAttribute('aria-expanded', 'false');
      });
    }

    function initCombobox(box) {
      if (box.dataset.cosComboboxReady) return;
      box.dataset.cosComboboxReady = '1';
      var input = box.querySelector('[data-cos-combobox-input]');
      var list = box.querySelector('[data-cos-combobox-list]');
      if (!input || !list) return;
      var dir = box.closest('[data-cos-directory]');
      var dataEl = dir ? dir.querySelector('[data-cos-cities-json]') : null;
      var cities = [];
      try {
        cities = dataEl && dataEl.textContent ? JSON.parse(dataEl.textContent.trim()) : [];
      } catch (e2) {
        cities = [];
      }
      if (!Array.isArray(cities)) cities = [];
      cities.sort(function (a, b) {
        return String(a).localeCompare(String(b), undefined, { sensitivity: 'base' });
      });
      var sel = -1;

      function filterCities(q) {
        var nq = norm(String(q).trim());
        if (!nq) return cities.slice();
        var out = [];
        for (var i = 0; i < cities.length; i++) {
          if (norm(String(cities[i])).indexOf(nq) !== -1) out.push(cities[i]);
        }
        return out;
      }

      function setExpanded(on) {
        input.setAttribute('aria-expanded', on ? 'true' : 'false');
      }

      function render() {
        var matched = filterCities(input.value);
        list.innerHTML = '';
        sel = -1;
        if (matched.length === 0) {
          list.hidden = true;
          box.classList.remove('is-open');
          setExpanded(false);
          return;
        }
        for (var j = 0; j < matched.length; j++) {
          var li = document.createElement('li');
          li.className = 'cosmetologists-combobox__option';
          li.setAttribute('role', 'option');
          li.textContent = matched[j];
          li.setAttribute('data-value', matched[j]);
          list.appendChild(li);
        }
        list.hidden = false;
        box.classList.add('is-open');
        setExpanded(true);
      }

      function close() {
        list.hidden = true;
        list.innerHTML = '';
        box.classList.remove('is-open');
        setExpanded(false);
        sel = -1;
      }

      function options() {
        return list.querySelectorAll('.cosmetologists-combobox__option');
      }

      function highlight() {
        var opts = options();
        for (var k = 0; k < opts.length; k++) {
          opts[k].setAttribute('aria-selected', k === sel ? 'true' : 'false');
        }
      }

      input.addEventListener('focus', render);
      input.addEventListener('input', render);
      input.addEventListener('keydown', function (e) {
        var opts = options();
        if (!list.hidden && opts.length) {
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            sel = Math.min(sel + 1, opts.length - 1);
            highlight();
            opts[sel].scrollIntoView({ block: 'nearest' });
            return;
          }
          if (e.key === 'ArrowUp') {
            e.preventDefault();
            sel = Math.max(sel - 1, 0);
            highlight();
            opts[sel].scrollIntoView({ block: 'nearest' });
            return;
          }
          if (e.key === 'Enter' && sel >= 0) {
            e.preventDefault();
            input.value = opts[sel].getAttribute('data-value') || opts[sel].textContent || '';
            close();
            return;
          }
          if (e.key === 'Escape') {
            e.preventDefault();
            close();
          }
        }
      });

      list.addEventListener('mousedown', function (e) {
        var li = e.target.closest('.cosmetologists-combobox__option');
        if (!li) return;
        e.preventDefault();
        input.value = li.getAttribute('data-value') || li.textContent || '';
        close();
        input.focus();
      });

      input.addEventListener('blur', function () {
        setTimeout(function () {
          if (!box.matches(':focus-within')) close();
        }, 180);
      });
    }

    function scanComboboxes(root) {
      (root || document).querySelectorAll('[data-cos-combobox]').forEach(initCombobox);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        scanComboboxes();
      });
    } else {
      scanComboboxes();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var sec = e.target && e.target.closest && e.target.closest('[id^="shopify-section-"]');
      if (sec) scanComboboxes(sec);
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cos-combobox]')) return;
      closeAllComboboxes();
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('[data-cos-filter-form]')) return;
      e.preventDefault();
      var inp = form.querySelector('[data-cos-filter-input]');
      if (inp) inp.setAttribute('data-cos-applied', inp.value.trim());
      var dir = form.closest('[data-cos-directory]');
      if (dir) apply(dir);
    });

    document.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-cos-tab]');
      if (!tab) return;
      var dir = tab.closest('[data-cos-directory]');
      if (dir) activateTab(dir, tab);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-accordions"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('image-accordions')) return;

  class ImageAccordions extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('accordion-tab'));
      this.panels = Array.from(this.querySelectorAll('[data-image-panel]'));
      this.mobileTabBtns = Array.from(this.querySelectorAll('[data-image-accordions-mobile-tab]'));
      this.mobilePanels = Array.from(this.querySelectorAll('[data-image-accordions-mobile-panel]'));

      if (!this.tabs.length || !this.panels.length) return;

      this.lastIndex = '0';

      this._onSummaryClickCapture = this.onSummaryClickCapture.bind(this);
      this.addEventListener('click', this._onSummaryClickCapture, true);

      this._onMobileTabClick = this.onMobileTabClick.bind(this);
      this.mobileTabBtns.forEach((btn) => {
        btn.addEventListener('click', this._onMobileTabClick);
      });

      this.tabs.forEach((tab) => {
        var details = tab.querySelector('details[data-image-accordion]');
        if (!details) return;
        details.addEventListener('toggle', () => this.onDetailsToggle(details, tab));
      });

      var initiallyOpen = this.tabs
        .map(function (t) {
          return t.querySelector('details[data-image-accordion]');
        })
        .find(function (d) {
          return d && d.open;
        });
      if (initiallyOpen) {
        this.lastIndex =
          initiallyOpen.getAttribute('data-image-accordion') ||
          (initiallyOpen.dataset && initiallyOpen.dataset.imageAccordion) ||
          '0';
      } else {
        var firstDetails = this.tabs[0].querySelector('details[data-image-accordion]');
        if (firstDetails) {
          firstDetails.open = true;
        }
      }

      this.syncFromState();
    }

    onMobileTabClick(e) {
      var btn = e.currentTarget;
      if (!btn || !btn.getAttribute) return;
      var idx = btn.getAttribute('data-image-accordions-mobile-tab');
      if (idx == null || idx === '') return;

      this.lastIndex = idx;
      this.syncPanels(this.lastIndex);

      var idxNum = parseInt(idx, 10);
      this.tabs.forEach(function (otherTab, i) {
        var otherDetails = otherTab.querySelector('details[data-image-accordion]');
        if (!otherDetails) return;
        if (i === idxNum) {
          otherDetails.open = true;
        } else if (otherDetails.open && typeof otherTab.shrink === 'function') {
          otherTab.shrink();
        } else {
          otherDetails.open = false;
        }
      });
    }

    syncMobileUi(index) {
      if (!this.mobileTabBtns.length) return;

      var s = String(index);
      this.mobileTabBtns.forEach(function (btn) {
        var on = btn.getAttribute('data-image-accordions-mobile-tab') === s;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      this.mobilePanels.forEach(function (panel) {
        var on = panel.getAttribute('data-image-accordions-mobile-panel') === s;
        panel.classList.toggle('is-active', on);
        panel.hidden = !on;
      });
    }

    onSummaryClickCapture(e) {
      var tab = e.target.closest('accordion-tab');
      if (!tab || this.tabs.indexOf(tab) === -1) return;

      var summary = tab.querySelector('summary');
      if (
        !summary ||
        (e.target !== summary &&
          typeof summary.contains === 'function' &&
          !summary.contains(e.target))
      ) {
        return;
      }

      var details = tab.querySelector('details[data-image-accordion]');
      if (!details || details.open) return;

      var idx =
        details.getAttribute('data-image-accordion') ||
        (details.dataset && details.dataset.imageAccordion);
      if (idx == null || idx === '') return;

      this.lastIndex = idx;
      this.tabs.forEach(function (otherTab) {
        if (otherTab === tab) return;
        var otherDetails = otherTab.querySelector('details[data-image-accordion]');
        if (
          otherDetails &&
          otherDetails.open &&
          typeof otherTab.shrink === 'function'
        ) {
          otherTab.shrink();
        }
      });
      this.syncPanels(this.lastIndex);
    }

    onDetailsToggle(details, tab) {
      if (details.open) {
        var idx =
          details.getAttribute('data-image-accordion') ||
          (details.dataset && details.dataset.imageAccordion);
        if (idx != null && idx !== '') {
          this.lastIndex = idx;
        }
        this.tabs.forEach((otherTab) => {
          if (otherTab === tab) return;
          var otherDetails = otherTab.querySelector('details[data-image-accordion]');
          if (otherDetails && otherDetails.open && typeof otherTab.shrink === 'function') {
            otherTab.shrink();
          }
        });
        this.syncPanels(this.lastIndex);
        return;
      }

      var anyOpen = this.tabs.some(function (t) {
        var d = t.querySelector('details[data-image-accordion]');
        return d && d.open;
      });
      if (!anyOpen) {
        this.syncPanels(this.lastIndex);
      }
    }

    syncFromState() {
      var open = this.tabs
        .map(function (t) {
          return t.querySelector('details[data-image-accordion]');
        })
        .find(function (d) {
          return d && d.open;
        });
      if (open) {
        this.lastIndex =
          open.getAttribute('data-image-accordion') ||
          (open.dataset && open.dataset.imageAccordion) ||
          this.lastIndex;
      }
      this.syncPanels(this.lastIndex);
    }

    syncPanels(index) {
      this.panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.dataset.imagePanel === String(index));
      });
      this.syncMobileUi(index);
    }
  }

  customElements.define('image-accordions', ImageAccordions);
})();

  } catch(e) { console.error(e); }
})();
})();
